<template>
  <base-dialog
    :title="title"
    :subtitle="subtitle"
    :description="description">

    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/common_location.png" />
        </div>

        <div class="col-8">
          <div class="form-group">
            <label>Maakunta</label>
            <select v-model="state" class="form-control">
              <option v-for="state in states" :key="'s-' + state.code" :value="state">{{ state.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label>Kunta</label>
            <select class="form-control" v-model="town">
              <option v-for="town in towns" :key="'t-' + town.code" :value="town">{{ town.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import Vue from 'vue'
  import BaseDialog from "./BaseDialog"
  import townService from "../../api/townService";

  export default {
    props: [
      'title',
      'subtitle',
      'description',
      'value'
    ],

    computed: {
      state: {
        get() {
          return townService.getStateByCode(this.value.stateCode)
        },
        set(state) {
          let town = townService.listTownsForState(state.code)[0]
          this.$emit('input', town)
        }
      },
      town: {
        get() {
          return this.value
        },
        set(town) {
          this.$emit('input', town)
        }
      },
      towns() {
        return townService.listTownsForState(this.state.code)
      }
    },

    data() {
      return {
//        selectedState: townService.getStateByCode('06'),
        states: []
      }
    },

    created() {
//      if(this.town == null) {
//        this.$store.commit('roomParams/SET_LOCATION', townService.getTownByCode('837'))
//      }

      this.states = townService.listStates()
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/BaseStateTownDialog.vue